import { isNil } from 'lodash';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockLimitedRequestSubjects, subjectsAreEqual } from 'venn-state';
import { getAnalyzedSubjectFromRequestSubject } from 'venn-utils';
import { StyledErrorState } from '../StyledErrorState';
import type { ErrorWrapper } from './errorWrapperTypes';

export const ComparisonDuplicateSubjectsError: ErrorWrapper = ({ blockId, children }) => {
  // TODO(willw) Refactor subject selectors s.t base subjects are filtered by type and limited to supported block number
  const requestSubjects = useRecoilValue(blockLimitedRequestSubjects(blockId));

  const [primarySubject, secondarySubject] = requestSubjects.map(getAnalyzedSubjectFromRequestSubject);

  if (!isNil(primarySubject) && subjectsAreEqual(primarySubject, secondarySubject)) {
    return (
      <StyledErrorState
        header="Select two different portfolios to compare"
        message="Configure subjects in the block settings panel to remove duplicate portfolios"
        selectedRefId={blockId}
      />
    );
  }

  return children;
};
